// extracted by mini-css-extract-plugin
export default {"page":"localizedArticle_page__cqyqz","header":"localizedArticle_header__9c0UC","content":"localizedArticle_content__od8P3","play":"localizedArticle_play__5ng-a"};